module.exports = __webpack_public_path__ + "img/bg_logo.02727813.png";